import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import api from "../api";

export default function SearchBar({ initial = {}, onSearch, variant = "hero" }) {
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState(initial.city || "Pune");
  const [area, setArea] = useState(initial.area || "");
  const [listingType, setListingType] = useState(initial.listing_type || "");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/meta/cities").then((r) => setCities(r.data.cities)).catch(() => {});
  }, []);

  const areas = cities.find((c) => c.name === city)?.areas || [];

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (city) params.set("city", city);
    if (area) params.set("area", area);
    if (listingType) params.set("listing_type", listingType);
    if (onSearch) onSearch({ city, area, listing_type: listingType });
    else navigate(`/properties?${params.toString()}`);
  };

  const inputCls =
    "w-full bg-neutral-50 border border-neutral-200 rounded-xl px-4 py-3 text-neutral-900 placeholder-neutral-400 focus:outline-none focus:border-brand-500 transition-colors";

  return (
    <form
      onSubmit={submit}
      data-testid="search-bar"
      className="bg-surface border border-neutral-200 shadow-card rounded-2xl p-4 grid gap-3 md:grid-cols-[1fr_1fr_1fr_auto]"
    >
      <div>
        <label className="block text-xs text-neutral-500 mb-1 ml-1">City</label>
        <select
          value={city}
          onChange={(e) => { setCity(e.target.value); setArea(""); }}
          data-testid="search-city"
          className={inputCls}
        >
          {cities.length === 0 && <option value="Pune">Pune</option>}
          {cities.map((c) => (
            <option key={c.name} value={c.name}>{c.name}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs text-neutral-500 mb-1 ml-1">Area</label>
        <input
          list="areas-list"
          value={area}
          onChange={(e) => setArea(e.target.value)}
          placeholder="Any area"
          data-testid="search-area"
          className={inputCls}
        />
        <datalist id="areas-list">
          {areas.map((a) => <option key={a} value={a} />)}
        </datalist>
      </div>
      <div>
        <label className="block text-xs text-neutral-500 mb-1 ml-1">Type</label>
        <select value={listingType} onChange={(e) => setListingType(e.target.value)} data-testid="search-listing-type" className={inputCls}>
          <option value="">Buy & Rent</option>
          <option value="Buy">Buy</option>
          <option value="Rent">Rent</option>
        </select>
      </div>
      <div className="flex items-end">
        <button
          type="submit"
          data-testid="search-submit-btn"
          className="w-full md:w-auto flex items-center justify-center gap-2 px-6 py-3 font-semibold text-white bg-gradient-to-r from-brand-500 to-brand-600 rounded-xl hover:shadow-soft transition-all active:scale-95"
        >
          <Search className="w-5 h-5" /> Search
        </button>
      </div>
    </form>
  );
}
